import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=12d77d33&scoped=true"
import script from "./UploadAvatar.vue?vue&type=script&lang=js"
export * from "./UploadAvatar.vue?vue&type=script&lang=js"
import style0 from "./UploadAvatar.vue?vue&type=style&index=0&id=12d77d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d77d33",
  null
  
)

export default component.exports